import React from "react";

const color = {
  dark: "#5b5b5b",
  white: "#fff",
};

const LeasingContract = ({ outlineColor = "dark", size = 72 }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="text-primary block"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect
          fill="#000000"
          opacity="0.00524553571"
          x="0"
          y="0"
          width="72"
          height="72"
        />
        <path
          d="M47.375,48.375 C47.375,52.10325 44.35325,55.125 40.625,55.125 C36.89675,55.125 33.875,52.10325 33.875,48.375 C33.875,44.647875 36.89675,41.625 40.625,41.625 C44.35325,41.625 47.375,44.647875 47.375,48.375 L47.375,48.375 Z"
          stroke="currentColor"
          strokeWidth="2"
          fillOpacity="0.3"
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          stroke="currentColor"
          strokeWidth="2"
          fillOpacity="0.3"
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="36.125 53.4045375 36.125 68.6246625 40.625 64.1246625 45.125 68.6246625 45.125 53.4045375"
        />
        <path
          d="M40.625,3.375 L40.625,13.5 C40.625,15.363 42.137,16.875 44,16.875 L54.125,16.875"
          stroke={color[outlineColor]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.625,57.375 L17,57.375 C15.137,57.375 13.625,55.863 13.625,54 L13.625,6.75 C13.625,4.887 15.137,3.375 17,3.375"
          stroke={color[outlineColor]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17,3.375 L41.75,3.375 L54.125,15.75 L54.125,54 C54.125,55.863 52.613,57.375 50.75,57.375 L49.625,57.375"
          stroke={color[outlineColor]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.375,21.375 L31.625,21.375"
          stroke={color[outlineColor]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.375,28.125 L47.375,28.125"
          stroke={color[outlineColor]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.375,34.875 L47.375,34.875"
          stroke={color[outlineColor]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default LeasingContract;
